import { combineReducers } from "@reduxjs/toolkit";
import stochasticCustomersReducer from "../modules/stochastic/features/CustomerList/slices/stochasticCustomersSlice";
import stochasticProspectsReducer from "../modules/stochastic/features/ProspectList/slices/stochasticProspectsSlice";
import stochasticInvoicesReducer from "../modules/stochastic/features/InvoiceList/slices/stochasticInvoicesSlice";
import stochasticCampaignProductsReducer from "@/modules/stochastic/features/CampaignProductManagement/slices/campaignProductsSlice";
import userAppSettingsReducer from "../modules/hub/features/UserAppSettings/slices/userAppSettingsSlice";
import quickBooksReportsReducer from "../modules/hub/features/FinancialReports/slices/quickBooksReportsSlice";
import periodReportReducer from "../modules/hub/features/FinancialReports/slices/periodReportSlice";
import fieldServiceExportsReducer from "../modules/hub/features/FieldServiceExports/slices/fieldServiceExportsSlice";
import usersReducer from "../modules/hub/features/UserManagement/slices/usersSlice";
import companiesReducer from "../modules/hub/features/CompanyManagement/slices/companiesSlice";
import editUserDetailsReducer from "../modules/hub/features/UserManagement/slices/editUserDetailsSlice";
import companyProfileReducer from "../modules/hub/features/UserAppSettings/slices/companyProfileSlice";
import userProfileReducer from "../modules/hub/features/UserAppSettings/slices/userProfileSlice";
import campaignListReducer from "../modules/stochastic/features/CampaignManagement/slices/campaignListSlice";
import campaignReducer from "../modules/stochastic/features/CampaignManagement/slices/campaignSlice";
import campaignBatchListReducer from "../modules/stochastic/features/CampaignBatchManagement/slices/campaignBatchListSlice";
import batchProspectReducer from "../modules/stochastic/features/BatchProspectManagement/slices/batchProspectSlice";
import campaignFilesReducer from "../modules/stochastic/features/CampaignFileManagement/slices/campaignFilesSlice";
import createCampaignReducer from "../modules/stochastic/features/CampaignManagement/slices/createCampaignSlice";
import campaignDetailsReducer from "../modules/stochastic/features/CampaignManagement/slices/CampaignDetailsSlice";
import editRolesAndPermissionsReducer from "../modules/hub/features/UserManagement/slices/editRolesAndPermissionsSlice";
import fetchRestrictedAddressesReducer from "@/modules/stochastic/features/DoNotMailManagement/slices/fetchRestrictedAddressesSlice";
import createRestrictedAddressReducer from "@/modules/stochastic/features/DoNotMailManagement/slices/createRestrictedAddressSlice";
import updateRestrictedAddressReducer from "@/modules/stochastic/features/DoNotMailManagement/slices/updateRestrictedAddressSlice";
import deleteRestrictedAddressReducer from "@/modules/stochastic/features/DoNotMailManagement/slices/deleteRestrictedAddressSlice";
import fetchSingleRestrictedAddressReducer from "@/modules/stochastic/features/DoNotMailManagement/slices/fetchSingleRestrictedAddressSlice";
import resourceManagementMetadataReducer from "@/modules/hub/features/ResourceManagement/slices/resourceManagementMetadataSlice";
import createUpdateResourceReducer from "@/modules/hub/features/ResourceManagement/slices/createUpdateResourceSlice";
import resourceListReducer from "@/modules/hub/features/ResourceManagement/slices/resourceListSlice";
import emailTemplateListReducer from "@/modules/emailManagement/features/EmailTemplateManagement/slices/emailTemplateListSlice";
import emailTemplateReducer from "@/modules/emailManagement/features/EmailTemplateManagement/slices/emailTemplateSlice";
import emailTemplateVariableListReducer from "@/modules/emailManagement/features/EmailTemplateManagement/slices/emailTemplateVariableListSlice";
import resourceCategoryReducer from "@/modules/hub/features/ResourceCategoryManagement/slice/resourceCategorySlice";
import resourceTagReducer from "@/modules/hub/features/ResourceTagManagement/slice/resourceTagSlice";
import emailTemplateCategoryReducer from "@/modules/emailManagement/features/EmailTemplateCategoryManagement/slice/emailTemplateCategorySlice";
import eventCategoryReducer from "@/modules/eventRegistration/features/EventCategoryManagement/slice/eventCategorySlice";
import emailCampaignReducer from "@/modules/emailManagement/features/EmailCampaignManagement/slices/emailCampaignSlice";
import emailCampaignListReducer from "@/modules/emailManagement/features/EmailCampaignManagement/slices/emailCampaignListSlice";
import emailCampaignStatusesReducer from "@/modules/emailManagement/features/EmailCampaignManagement/slices/emailCampaignStatusesSlice";
import emailCampaignEventLogListReducer from "@/modules/emailManagement/features/EmailEventLogsManagement/slices/emailCampaignEventLogListSlice";
import emailCampaignEventLogsMetadataReducer from "@/modules/emailManagement/features/EmailEventLogsManagement/slices/emailCampaignEventLogsMetadataSlice";
import eventDirectoryReducer from "@/modules/eventRegistration/features/EventDirectory/slices/eventDirectorySlice";
import createUpdateEventReducer from "@/modules/eventRegistration/features/EventManagement/slices/createUpdateEventSlice";
import eventListReducer from "@/modules/eventRegistration/features/EventManagement/slices/eventListSlice";
import createUpdateEventSessionReducer from "@/modules/eventRegistration/features/EventSessionManagement/slices/createUpdateEventSessionSlice";
import eventSessionListReducer from "@/modules/eventRegistration/features/EventSessionManagement/slices/eventSessionListSlice";
import eventSessionDayReducer from "@/modules/eventRegistration/features/EventSessionManagement/slices/eventSessionDaySlice";
import eventTagReducer from "@/modules/eventRegistration/features/EventTagManagement/slices/eventTagSlice";
import eventTypeReducer from "@/modules/eventRegistration/features/EventTypeManagement/slices/eventTypeSlice";
import notificationTypeReducer from "@/modules/eventNotifications/features/NotificationTypeManagement/slice/notificationTypeSlice";
import wideSidebarReducer from "@/app/globalSlices/wideSidebarSlice";
import fileManagerDialogReducer from "@/app/globalSlices/fileManagerDialogSlice";
import appStripReducer from "@/app/globalSlices/appStripSlice";
import eventCheckoutReducer from "@/modules/eventRegistration/features/EventRegistration/slices/eventCheckoutSlice";
import salesCoachingReducer from "@/modules/salesCoaching/features/SalesCallScoring/slices/salesCoachingSlice";
import salesCoachingScoringSettingsReducer from "@/modules/salesCoaching/features/SalesCoachingScoringSettings/slices/salesCoachingScoringSettingsSlice";
import callScoringSettingsReducer from "@/modules/transcripts/features/CallScoringSettings/slices/callScoringSettingsSlice";
import eventCheckoutEntryReducer from "@/modules/eventRegistration/features/EventRegistration/slices/eventCheckoutEntrySlice";
import eventInstructorReducer from "@/modules/eventRegistration/features/EventInstructorManagement/slices/eventInstructorSlice";
import locationListReducer from "@/modules/stochastic/features/LocationsList/slices/locationListSlice";
import locationReducer from "@/modules/stochastic/features/LocationsList/slices/locationSlice";
import voucherListReducer from "@/modules/eventRegistration/features/EventVoucherManagement/slices/VoucherListSlice";
import voucherReducer from "@/modules/eventRegistration/features/EventVoucherManagement/slices/VoucherSlice";
import venueListReducer from "@/modules/eventRegistration/features/EventVenueManagement/slices/VenueListSlice";
import venueReducer from "@/modules/eventRegistration/features/EventVenueManagement/slices/VenueSlice";
import DiscountListReducer from "@/modules/eventRegistration/features/EventDiscountManagement/slices/DiscountListSlice";
import DiscountReducer from "@/modules/eventRegistration/features/EventDiscountManagement/slices/DiscountSlice";
import DiscountMetadataReducer from "@/modules/eventRegistration/features/EventDiscountManagement/slices/DiscountMetadataSlice";
import partnerNetworkReducer from "@/modules/partnerNetwork/store/partnerNetworkReducer";
import resourceLibraryReducer from "@/modules/hub/features/ResourceLibrary/slices/resourceLibrarySlice";
import StochasticDashboardReducer from "@/modules/stochastic/features/SalesAndCustomerDashboard/slice/StochasticDashboardSlice";
import StochasticDashboardLegacyReducer from "@/modules/stochastic/features/DashboardPage/slice/StochasticDashboardSlice";
import enrollmentsWaitlistReducer from "@/modules/eventRegistration/features/EventWaitlist/slices/enrollmentsWaitlistSlice";
import fileManagementReducer from "@/modules/hub/features/FileManagement/slices/fileManagementSlice";
import fileManagementTagReducer from "@/modules/hub/features/FileManagement/slices/fileManagementTagSlice";
import fileManagerMetadataReducer from "@/modules/hub/features/FileManagement/slices/fileManagerMetadataSlice";
import resourceLibraryMetadataReducer from "@/modules/hub/features/ResourceLibrary/slices/resourceLibraryMetadataSlice";
import DoNotMailImportReducer from "@/modules/stochastic/features/DoNotMailImport/slice/DoNotMailListImportSlice";
import eventTransactionsReducer from "@/modules/eventRegistration/features/EventWaitlist/slices/eventTransactionsSlice";
import podcastsReducer from "@/modules/hub/features/Podcasts/slices/podcastsSlice";
import podcastsMetadataReducer from "@/modules/hub/features/Podcasts/slices/podcastsMetadataSlice";
import newsReducer from "@/modules/hub/features/News/slices/newsSlice";
import searchReducer from "@/modules/hub/features/Search/slices/searchSlice";
import purgeInvoicesReducer from "@/modules/stochastic/features/PurgeInvoices/slices/purgeInvoicesSlice";
import roiDashboardReducer from "@/modules/stochastic/features/ROIDashboard/slice/roiDashboardSlice";
import campaignJobStatusDataReducer from "@/modules/administration/features/Stochastic/CampaignJobStatus/slices/campaignJobStatusDataSlice";
import campaignStatusDataReducer from "@/modules/administration/features/Stochastic/CampaignStatus/slices/campaignStatusDataSlice";
import campaignStatusMetadataReducer from "@/modules/administration/features/Stochastic/CampaignStatus/slices/campaignStatusMetadataSlice";
import campaignStatusDownloadCsvReducer from "@/modules/administration/features/Stochastic/CampaignStatus/slices/campaignStatusDownloadCsvSlice";
import bulkBatchStatusDetailsMetadataReducer from "@/modules/administration/features/Stochastic/CampaignJobStatus/slices/bulkBatchStatusDetailsMetadataSlice";

// Main-specific imports
import membershipSkuReducer from "@/modules/hub/features/MembershipSkuManagement/slice/membershipSkuSlice";
import campaignBillingBatchesReducer from "@/modules/stochastic/features/CampaignBillingManagement/slices/campaignBillingBatchesSlice";
import weekSummaryReducer from "@/modules/stochastic/features/CampaignBillingManagement/slices/weekSummarySlice";
import invoicePreviewReducer from "@/modules/stochastic/features/CampaignBillingManagement/slices/invoicePreviewSlice";
import draftInvoiceReducer from "@/modules/stochastic/features/CampaignBillingManagement/slices/draftInvoiceSlice";
import totalAddressableMarketReducer from "@/modules/stochastic/features/TotalAddressableMarket/slices/totalAddressableMarketSlice";
import adminUsersReducer from "@/modules/administration/features/UserManagement/slices/adminUsersSlice";
import eventNotificationsReducer from "@/modules/administration/features/Events/Notifications/slices/eventNotificationsSlice";
import integrationsStatusReducer from "@/modules/hub/features/UserAppSettings/slices/integrationsStatusSlice";

// Labs-specific imports
import checkoutAddOnsReducer from "@/modules/eventRegistration/features/EventCheckout/slices/checkoutAddOnsSlice";

// Learning Center slices
import badgeAwardsReducer from "@/modules/learningCenter/features/BadgeManagement/slices/badgeAwardSlice";
import badgesReducer from "@/modules/learningCenter/features/BadgeManagement/slices/badgeSlice";
import categoryManagementReducer from "@/modules/learningCenter/features/CategoryManagement/slices/categoryManagementSlice";
import courseDetailReducer from "@/modules/learningCenter/features/CourseDirectory/slices/courseDetailSlice";
import courseDirectoryReducer from "@/modules/learningCenter/features/CourseDirectory/slices/courseDirectorySlice";
import moduleProgressReducer from "@/modules/learningCenter/features/CourseDirectory/slices/moduleProgressSlice";
import enrollmentReducer from "@/modules/learningCenter/features/CourseDirectory/slices/enrollmentSlice";
import courseEditorReducer from "@/modules/learningCenter/features/CourseManagement/slices/courseEditorSlice";
import courseManagementReducer from "@/modules/learningCenter/features/CourseManagement/slices/courseManagementSlice";
import courseReducer from "@/modules/learningCenter/features/CourseManagement/slices/courseSlice";
import pathViewerReducer from "@/modules/learningCenter/features/LearningPathViewer/slices/pathViewerSlice";
import pathPreviewReducer from "@/modules/learningCenter/features/LearningPathViewer/slices/pathPreviewSlice";
import userPathsReducer from "@/modules/learningCenter/features/LearningPathViewer/slices/userPathsSlice";
import customChecklistTasksReducer from "@/modules/learningCenter/features/LearningPaths/slices/customChecklistTasksSlice";
import courseLibraryReducer from "@/modules/learningCenter/features/LearningPaths/slices/courseLibrarySlice";
import quizLibraryReducer from "@/modules/learningCenter/features/LearningPaths/slices/quizLibrarySlice";
import learningPathsReducer from "@/modules/learningCenter/features/LearningPaths/slices/learningPathsSlice";
import pathBuilderGraphReducer from "@/modules/learningCenter/features/LearningPaths/slices/pathBuilderGraphSlice";
import pathEnrollmentsReducer from "@/modules/learningCenter/features/LearningPaths/slices/pathEnrollmentsSlice";
import quizManagementReducer from "@/modules/learningCenter/features/QuizManagement/slices/quizManagementSlice";
import diagnosticReviewReducer from "@/modules/growthStages/features/Diagnostics/slices/diagnosticReviewSlice";
import diagnosticCompaniesReducer from "@/modules/growthStages/features/Diagnostics/slices/diagnosticCompaniesSlice";
import skillManagementReducer from "@/modules/learningCenter/features/SkillManagement/slices/skillManagementSlice";
import moduleLibraryReducer from "@/modules/learningCenter/features/ModuleLibrary/slices/moduleLibrarySlice";
import bundleDirectoryReducer from "@/modules/learningCenter/features/BundleDirectory/slices/bundleDirectorySlice";
import bundleDetailReducer from "@/modules/learningCenter/features/BundleDirectory/slices/bundleDetailSlice";
import programEditorReducer from "@/modules/learningCenter/features/ProgramBuilder/slices/programEditorSlice";
import discoveryHubReducer from "@/modules/learningCenter/features/DiscoveryHub/slices/discoveryHubSlice";
import heroPanelAdminReducer from "@/modules/learningCenter/features/HeroPanelAdmin/slices/heroPanelAdminSlice";
import programCheckoutReducer from "@/modules/learningCenter/features/ProgramCheckout/slices/programCheckoutSlice";
import taskTemplatesReducer from "@/modules/learningCenter/features/TaskTemplates/slices/taskTemplatesSlice";
import trainingCenterReducer from "@/modules/learningCenter/features/TrainingCenter/slices/trainingCenterSlice";
import managerTeamViewReducer from "@/modules/learningCenter/features/ManagerTeamView/slices/managerTeamViewSlice";

// Partner Network slices
import fieldMappingsReducer from "@/modules/partnerNetwork/features/PartnerManagement/slices/fieldMappingsSlice";
import reportsReducer from "@/modules/partnerNetwork/features/PartnerManagement/slices/reportsSlice";

// Quick Links slice
import quickLinksReducer from "@/modules/hub/features/QuickLinks/slices/quickLinksSlice";

// Transcripts slices
import callScoringReducer from "@/modules/transcripts/features/CallScoring/slices/callScoringSlice";
import transcriptListReducer from "@/modules/transcripts/features/TranscriptManagement/slices/transcriptListSlice";

// Reports slices
import eventReportsReducer from "@/modules/reports/features/EventReports/slices/eventReportsSlice";

// Zoom-specific slices
import notificationSettingsReducer from "@/modules/hub/features/NotificationSettings/slices/notificationSettingsSlice";
import emailTemplateSettingsReducer from "@/modules/transcripts/features/EmailTemplateSettings/slices/emailTemplateSettingsSlice";
import callIntelligenceReducer from "./callIntelligenceSlice";
import transcriptionQueueReducer from "@/modules/transcriptionQueue/slices/queueSlice";
import transcriptionMetricsReducer from "@/modules/transcriptionQueue/slices/metricsSlice";
import transcriptionAlertsReducer from "@/modules/transcriptionQueue/slices/alertsSlice";
import fathomQueueReducer from "@/modules/transcriptionQueue/slices/fathomQueueSlice";

// CapEx slices
import capexReportReducer from "@/modules/capex/features/CapExReport/slices/capexReportSlice";
import monthlySummaryReducer from "@/modules/capex/features/MonthlySummary/slices/monthlySummarySlice";
import bulkHoursReducer from "@/modules/capex/features/BulkHours/slices/bulkHoursSlice";

// Coaching slices
import coachingDashboardReducer from "@/modules/coaching/features/Dashboard/slices/coachingDashboardSlice";
import learningPathsDashboardReducer from "@/modules/coaching/features/LearningPathsDashboard/slices/learningPathsDashboardSlice";

// Community Groups slices
import groupsListReducer from "@/modules/communityGroups/features/GroupsList/slices/groupsListSlice";
import groupDetailReducer from "@/modules/communityGroups/features/GroupDetail/slices/groupDetailSlice";

// Call Intelligence Settings slices
import callSettingsReducer from "@/modules/callIntelligence/features/Settings/components/CallSettings/callSettingsSlice";

// Scheduled Reports
import scheduledReportsReducer from "@/modules/callIntelligence/features/ScheduledReports/slices/scheduledReportsSlice";

// Product Storefront slices
import productDirectoryReducer from "@/modules/productStorefront/features/ProductDirectory/slices/productDirectorySlice";
import productCheckoutReducer from "@/modules/productStorefront/features/ProductCheckout/slices/productCheckoutSlice";
import productListReducer from "@/modules/productStorefront/features/ProductManagement/slices/productListSlice";
import createUpdateProductReducer from "@/modules/productStorefront/features/ProductManagement/slices/createUpdateProductSlice";
import productCategoryReducer from "@/modules/productStorefront/features/ProductCategoryManagement/slice/productCategorySlice";
import productOrderListReducer from "@/modules/productStorefront/features/ProductOrderManagement/slices/productOrderListSlice";
import productReportReducer from "@/modules/productStorefront/features/ProductReport/slices/productReportSlice";

const rootReducer = combineReducers({
  stochasticCustomers: stochasticCustomersReducer,
  stochasticProspects: stochasticProspectsReducer,
  stochasticInvoices: stochasticInvoicesReducer,
  stochasticCampaignProducts: stochasticCampaignProductsReducer,
  userAppSettings: userAppSettingsReducer,
  quickBooksReports: quickBooksReportsReducer,
  periodReport: periodReportReducer,
  fieldServiceExports: fieldServiceExportsReducer,
  users: usersReducer,
  editUserDetails: editUserDetailsReducer,
  companies: companiesReducer,
  companyProfile: companyProfileReducer,
  userProfile: userProfileReducer,
  campaignList: campaignListReducer,
  campaign: campaignReducer,
  campaignBatchList: campaignBatchListReducer,
  batchProspect: batchProspectReducer,
  campaignFiles: campaignFilesReducer,
  createCampaign: createCampaignReducer,
  campaignDetails: campaignDetailsReducer,
  emailTemplate: emailTemplateReducer,
  emailTemplateList: emailTemplateListReducer,
  emailTemplateVariableList: emailTemplateVariableListReducer,
  editRolesAndPermissions: editRolesAndPermissionsReducer,
  fetchRestrictedAddresses: fetchRestrictedAddressesReducer,
  createRestrictedAddress: createRestrictedAddressReducer,
  updateRestrictedAddress: updateRestrictedAddressReducer,
  deleteRestrictedAddress: deleteRestrictedAddressReducer,
  fetchSingleRestrictedAddress: fetchSingleRestrictedAddressReducer,
  resourceManagementMetadataReducer: resourceManagementMetadataReducer,
  createUpdateResource: createUpdateResourceReducer,
  resourceCategory: resourceCategoryReducer,
  resourceTag: resourceTagReducer,
  resourceList: resourceListReducer,
  emailTemplateCategory: emailTemplateCategoryReducer,
  eventCategory: eventCategoryReducer,
  emailCampaign: emailCampaignReducer,
  emailCampaignList: emailCampaignListReducer,
  emailCampaignStatuses: emailCampaignStatusesReducer,
  emailCampaignEventLogList: emailCampaignEventLogListReducer,
  emailCampaignEventLogsMetadata: emailCampaignEventLogsMetadataReducer,
  eventDirectory: eventDirectoryReducer,
  createUpdateEvent: createUpdateEventReducer,
  eventList: eventListReducer,
  createUpdateEventSession: createUpdateEventSessionReducer,
  eventSessionList: eventSessionListReducer,
  eventSessionDay: eventSessionDayReducer,
  eventTag: eventTagReducer,
  eventType: eventTypeReducer,
  notificationType: notificationTypeReducer,
  wideSidebar: wideSidebarReducer,
  fileManagerDialog: fileManagerDialogReducer,
  appStrip: appStripReducer,
  eventCheckout: eventCheckoutReducer,
  eventCheckoutEntry: eventCheckoutEntryReducer,
  eventInstructor: eventInstructorReducer,
  locationList: locationListReducer,
  location: locationReducer,
  voucherList: voucherListReducer,
  voucher: voucherReducer,
  venueList: venueListReducer,
  venue: venueReducer,
  discountList: DiscountListReducer,
  discount: DiscountReducer,
  discountMetadata: DiscountMetadataReducer,
  salesCoaching: salesCoachingReducer,
  salesCoachingScoringSettings: salesCoachingScoringSettingsReducer,
  callScoringSettings: callScoringSettingsReducer,
  partnerNetwork: partnerNetworkReducer,
  resourceLibrary: resourceLibraryReducer,
  stochasticDashboard: StochasticDashboardReducer,
  stochasticDashboardLegacy: StochasticDashboardLegacyReducer,
  enrollmentsWaitlist: enrollmentsWaitlistReducer,
  fileManagement: fileManagementReducer,
  fileManagementTag: fileManagementTagReducer,
  fileManagerMetadata: fileManagerMetadataReducer,
  resourceLibraryMetadata: resourceLibraryMetadataReducer,
  doNotMailImport: DoNotMailImportReducer,
  eventTransactions: eventTransactionsReducer,
  podcasts: podcastsReducer,
  podcastsMetadata: podcastsMetadataReducer,
  news: newsReducer,
  search: searchReducer,
  purgeInvoices: purgeInvoicesReducer,
  roiDashboard: roiDashboardReducer,
  campaignStatusData: campaignStatusDataReducer,
  campaignJobStatusData: campaignJobStatusDataReducer,
  campaignStatusMetadata: campaignStatusMetadataReducer,
  campaignStatusDownloadCsv: campaignStatusDownloadCsvReducer,
  bulkBatchStatusDetailsMetadata: bulkBatchStatusDetailsMetadataReducer,

  // Main-specific
  membershipSku: membershipSkuReducer,
  campaignBillingBatches: campaignBillingBatchesReducer,
  weekSummary: weekSummaryReducer,
  invoicePreview: invoicePreviewReducer,
  draftInvoice: draftInvoiceReducer,
  adminUsers: adminUsersReducer,
  eventNotifications: eventNotificationsReducer,
  totalAddressableMarket: totalAddressableMarketReducer,
  integrationsStatus: integrationsStatusReducer,

  // Labs-specific
  checkoutAddOns: checkoutAddOnsReducer,

  // Learning Center
  badgeAwards: badgeAwardsReducer,
  badges: badgesReducer,
  categoryManagement: categoryManagementReducer,
  courseDetail: courseDetailReducer,
  courseDirectory: courseDirectoryReducer,
  moduleProgress: moduleProgressReducer,
  enrollment: enrollmentReducer,
  courseEditor: courseEditorReducer,
  courseManagement: courseManagementReducer,
  course: courseReducer,
  pathViewer: pathViewerReducer,
  pathPreview: pathPreviewReducer,
  userPaths: userPathsReducer,
  customChecklistTasks: customChecklistTasksReducer,
  courseLibrary: courseLibraryReducer,
  quizLibrary: quizLibraryReducer,
  learningPaths: learningPathsReducer,
  pathBuilderGraph: pathBuilderGraphReducer,
  pathEnrollments: pathEnrollmentsReducer,
  quizManagement: quizManagementReducer,
  diagnosticReview: diagnosticReviewReducer,
  diagnosticCompanies: diagnosticCompaniesReducer,
  skillManagement: skillManagementReducer,
  moduleLibrary: moduleLibraryReducer,
  bundleDirectory: bundleDirectoryReducer,
  bundleDetail: bundleDetailReducer,
  programEditor: programEditorReducer,
  discoveryHub: discoveryHubReducer,
  heroPanelAdmin: heroPanelAdminReducer,
  programCheckout: programCheckoutReducer,
  taskTemplates: taskTemplatesReducer,
  trainingCenter: trainingCenterReducer,
  managerTeamView: managerTeamViewReducer,

  // Partner Network
  fieldMappings: fieldMappingsReducer,
  reports: reportsReducer,

  // Transcripts
  callScoring: callScoringReducer,
  transcriptList: transcriptListReducer,

  // Reports
  eventReports: eventReportsReducer,

  // Quick Links
  quickLinks: quickLinksReducer,

  // Zoom-specific
  notificationSettings: notificationSettingsReducer,
  emailTemplateSettings: emailTemplateSettingsReducer,
  callIntelligence: callIntelligenceReducer,
  transcriptionQueue: transcriptionQueueReducer,
  transcriptionMetrics: transcriptionMetricsReducer,
  transcriptionAlerts: transcriptionAlertsReducer,
  fathomQueue: fathomQueueReducer,

  // CapEx
  capexReport: capexReportReducer,
  monthlySummary: monthlySummaryReducer,
  bulkHours: bulkHoursReducer,

  // Coaching
  coachingDashboard: coachingDashboardReducer,
  learningPathsDashboard: learningPathsDashboardReducer,

  // Community Groups
  groupsList: groupsListReducer,
  groupDetail: groupDetailReducer,

  // Call Intelligence Settings
  callSettings: callSettingsReducer,

  // Scheduled Reports
  scheduledReports: scheduledReportsReducer,

  // Product Storefront
  productDirectory: productDirectoryReducer,
  productCheckout: productCheckoutReducer,
  productList: productListReducer,
  createUpdateProduct: createUpdateProductReducer,
  productCategory: productCategoryReducer,
  productOrderList: productOrderListReducer,
  productReport: productReportReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
